/* eslint-disable no-shadow */
import { useContext, useEffect } from 'react';
import { loadVenueInventory } from './venueDetailsLoaders';
import PathBuilderContext from '../WidgetApp/PathBuilderContext';

// useResyCoreEffect Custom Hook
//
// Listens for updates to core date, seats, or time values, and updates accordingly.
// Does not return anything.
const useResyCoreEffect = ({
  getVenueInventoryThunk,
  loadReservations,
  selectedDate,
  selectedQuantity,
  selectedTime,
  venueId,
}) => {
  const pathBuilder = useContext(PathBuilderContext);
  const doUpdate = (venueId, selectedDate, selectedQuantity) => {
    loadVenueInventory({ getVenueInventoryThunk, selectedQuantity, venueId });
    loadReservations(venueId, selectedDate, selectedQuantity);
  };
  // selectedDate useEffect
  useEffect(() => {
    /* istanbul ignore else */
    if (venueId) {
      doUpdate(venueId, selectedDate, selectedQuantity);
    }
  }, [selectedDate]);

  // selectedQuantity useEffect
  useEffect(() => {
    /* istanbul ignore else */
    if (venueId) {
      doUpdate(venueId, selectedDate, selectedQuantity);
    }
  }, [selectedQuantity]);

  // selectedTime useEffect
  useEffect(() => {
    pathBuilder.setSearch(selectedQuantity, selectedDate);
    /* istanbul ignore else */
    if (venueId) {
      doUpdate(venueId, selectedDate, selectedQuantity);
    }
  }, [selectedTime]);
};

export default useResyCoreEffect;
